import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@rq-ratings/pro-light-svg-icons'
import { useMutation } from '@tanstack/react-query'
import React from 'react'

import useNotyf from '../../../../hooks/useNotyf'
import { useShowGenericServerError } from '../../../../hooks/useShowGenericServerError'
import { highlightTableRowElement } from '../../../../lib/helpers/domHelpers'
import referralLinkService from '../../../../lib/services/referralLinkService'
import { shareableLinkRowId } from '../../../../pages/emailAndCalendarIntegration/components/ShareableLinks/helpers'
import ActionButton from '../../ActionButton'
import { useInvalidateReferralLinksQueries } from '../hooks/useInvalidateReferralLinksQueries'

interface Props {
  referralLinkCode: string
}

const DuplicateButton: React.FC<Props> = ({ referralLinkCode }) => {
  const notyf = useNotyf()
  const showGenericServerError = useShowGenericServerError()
  const invalidateReferralLinkQueries = useInvalidateReferralLinksQueries()

  const duplicateLinkMutation = useMutation({
    mutationFn: (code: string) => referralLinkService.duplicateLink(code),
    onSuccess: async (newLink) => {
      await invalidateReferralLinkQueries()

      setTimeout(() => {
        const newRowElement = document.getElementById(
          shareableLinkRowId(newLink.id),
        )

        highlightTableRowElement(newRowElement)
      }, 200)

      notyf.success('Link duplicated successfully')
    },
    onError: showGenericServerError,
  })

  return (
    <ActionButton
      isProcessing={duplicateLinkMutation.isPending}
      isProcessingText="Duplicating"
      variant="outline-primary"
      className="d-flex justify-content-center align-items-center btn-fluid text-sm"
      style={{ gap: '6px' }}
      onClick={() => duplicateLinkMutation.mutate(referralLinkCode)}
    >
      <FontAwesomeIcon icon={faCopy} />
      Duplicate
    </ActionButton>
  )
}

export default DuplicateButton
